import { Translation } from 'react-i18next';
import React from 'react';

import { ColumnProps } from '@/components';
import { SpamAppealRecord, SpamMarkRecord } from './types';
import style from './index.module.css';
import { formatDate } from '@/utils';
import { UserCard } from '../../UserCard';
export const getAppealColumns = (): Array<ColumnProps<SpamAppealRecord>> => [
  {
    width: '16%',
    key: 'create_at',
    title: <Translation>{t => t('SpamReport_columns.19hvy')}</Translation>,

    render({ row }) {
      return <div className={style.date}>{formatDate(row.create_at * 1000, 'YYYY/MM/DD')}</div>;
    },
  },
  {
    width: '42%',
    key: 'comment',
    title: <Translation>{t => t('SpamReport_columns.15hhxlk')}</Translation>,

    render({ row }) {
      return <div className={style.comment}>{row.comment}</div>;
    },
  },

  {
    title: <Translation>{t => t('SpamReport_columns.12xjg42')}</Translation>,
    key: 'audit_comment',
    width: '42%',
    render: ({ row }) => {
      const isPending = row.audit_result === null;
      return (
        <div className={style.result}>
          <span className={style.status}>
            {isPending ? (
              <Translation>{t => t('SpamReport_columns.pending')}</Translation>
            ) : row.audit_result ? (
              <Translation>{t => t('SpamReport_columns.accepted')}</Translation>
            ) : (
              <Translation>{t => t('SpamReport_columns.rejected')}</Translation>
            )}
          </span>
          {row.audit_comment ? (
            `: ${row.audit_comment}`
          ) : isPending ? (
            <Translation>{t => t('SpamReport_columns.maxDay')}</Translation>
          ) : (
            ''
          )}
        </div>
      );
    },
  },
];

export const getUserMarkColumns = (refetch: () => void): Array<ColumnProps<SpamMarkRecord>> => [
  {
    width: '42%',
    key: 'creator',
    title: <Translation>{t => t('SpamReport_columns.1kpnv')}</Translation>,

    render({ row }) {
      return (
        <div className={style.user}>
          <UserCard
            data={row.creator.desc}
            onMemoChange={() => refetch()}
            enableClickToOpenProfile></UserCard>
        </div>
      );
    },
  },
  {
    width: '42%',
    key: 'result',
    title: <Translation>{t => t('SpamReport_columns.45zn3o')}</Translation>,

    render({ row }) {
      return <div className={style.label}>{row.result ? 'Sybil' : 'Non-sybil'}</div>;
    },
  },
  {
    width: '16%',
    key: 'update_at',
    title: <Translation>{t => t('SpamReport_columns.19hvy')}</Translation>,

    render({ row }) {
      return <div className={style.date}>{formatDate(row.update_at * 1000, 'YYYY/MM/DD')}</div>;
    },
  },
];
